import React from 'react';

export default () => (
  <svg 
    width="21" 
    height="21" 
    viewBox="0 0 21 21" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.5 10.5H4.5V21H1.5V10.5ZM6.5 0H9.5V21H6.5V0ZM11.5 8.4H14.5V21H11.5V8.4ZM16.5 4.2H19.5V21H16.5V4.2Z" fill="currentColor" />
  </svg>
);
